import TextAreaAPI from './text-area-api';

export default TextAreaAPI;
